import { useCallback, useEffect, useRef, useState } from 'react';
import { Alert, Box, Button, CircularProgress, Container, Paper, Typography } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import NodeAPI from '../api';
import { useAuth } from '../context/AuthContext';
import { clearPendingQuiz, getPendingQuiz } from '../utils/pendingQuiz';

export default function PendingQuizSave() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const attempted = useRef(false);
  const [status, setStatus] = useState('saving');
  const [error, setError] = useState('');

  const save = useCallback(async () => {
    const quiz = getPendingQuiz();
    if (!quiz) {
      navigate('/categories', { replace: true });
      return;
    }
    setStatus('saving');
    setError('');
    try {
      await NodeAPI.post('/quiz/save', { ...quiz, userId: user.id });
      clearPendingQuiz();
      setStatus('saved');
    } catch (err) {
      setError(err.response?.data?.error || err.response?.data?.msg || 'Could not save your quiz. Please try again.');
      setStatus('error');
    }
  }, [navigate, user.id]);

  useEffect(() => {
    if (attempted.current) return;
    attempted.current = true;
    save();
  }, [save]);

  return <Container maxWidth="sm" sx={{ mt: 8 }}>
    <Paper sx={{ p: 4, textAlign: 'center' }}>
      <Typography variant="h5" gutterBottom>Save your quiz</Typography>
      {status === 'saving' && <Box><CircularProgress /><Typography sx={{ mt: 2 }}>Saving your quiz...</Typography></Box>}
      {status === 'saved' && <><Alert severity="success" sx={{ mb: 2 }}>Quiz saved to your account.</Alert><Button component={Link} to="/categories" variant="contained">View categories</Button></>}
      {status === 'error' && <><Alert severity="error" sx={{ mb: 2 }}>{error}</Alert><Button variant="contained" onClick={save}>Try again</Button><Button component={Link} to="/categories" sx={{ ml: 1 }}>Later</Button></>}
    </Paper>
  </Container>;
}
